import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { applyHeadMeta } from "@/lib/headMeta";
import { SITE_ORIGIN } from "@/lib/share";

export default function DemoNotice({ hub = false }: { hub?: boolean }) {
  const title = hub ? "SIIS Athlete Business Hub Demo" : "SIIS Athlete Profile Demo";
  const path = hub ? "/athlete-business-hub-demo" : "/athlete-profile-demo";
  useEffect(() => applyHeadMeta({
    title: `${title} — Say It In Sports`,
    description: "Avery Morgan is a fictional demo athlete. All content and figures are illustrative. Nothing is saved or purchased.",
    url: `${SITE_ORIGIN}${path}`, type: "website", robots: "noindex, follow",
  }), [title, path]);
  return (
    <aside aria-label="Demo notice" className="sticky top-0 z-40 bg-secondary text-secondary-foreground">
      <div className="container flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2 text-xs">
        <div>
          <p className="font-semibold text-primary-on-navy">{hub ? "Sample Business Hub · Demo data · Nothing is saved" : "SIIS Athlete Profile Demo · Nothing is saved"}</p>
          <p>Avery Morgan is fictional. All content, figures and products are illustrative.</p>
        </div>
        <Link to="/become-an-athlete" className="inline-flex min-h-[44px] items-center gap-1 font-semibold underline-offset-4 hover:underline">
          Want a profile like this? Get started <ArrowRight className="h-3.5 w-3.5" aria-hidden />
        </Link>
      </div>
    </aside>
  );
}